import React, { useEffect, useState } from "react";
import {useNavigate, useParams } from "react-router-dom";
import "./TripItinerary.css";

const TripItinerary = () => {
  const navigate = useNavigate();
  const { title } = useParams(); // title from URL
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);

  const SHEETDB_BASE = "https://sheetdb.io/api/v1/bkpus34ip4xtl"; // Replace with your SheetDB ID
  const sheetName = `Itenary_${title}`; // e.g., Itenary_Manali

  useEffect(() => {
    fetch(`${SHEETDB_BASE}?sheet=${sheetName}`)
      .then((res) => res.json())
      .then((data) => {
        setData(data);
        setLoading(false);
      })
      .catch((err) => {
        console.error("Error fetching data:", err);
        setLoading(false);
      });
  }, [sheetName]);

  if (loading) return <div className="loading">Loading itinerary...</div>;
  if (!data || data.length === 0) return <div className="error">No data found</div>;

  // Helper functions to extract various fields
  const getField = (field) => data.find((item) => item.Section === field)?.Content || "";

  const getDays = data.filter((row) => row.Section?.toLowerCase().includes("day"));
  const images = getField("Images").split(";").map((url) => url.trim()).filter(Boolean);
  const inclusions = getField("Inclusions").split(";").map((item) => item.trim()).filter(Boolean);
  const exclusions = getField("Exclusions").split(";").map((item) => item.trim()).filter(Boolean);

  return (
    <div className="trip-itinerary">
      <h1 className="animated-heading">{title}</h1>
      <h2 className="subheading">{getField("Header")}</h2>
      <p className="description">{getField("Description")}</p>

      <section className="daywise-section">
        <h3>Day-wise Itinerary</h3>
        <div className="day-cards">
          {getDays.map((day, index) => (
            <div key={index} className="day-card">
              <h4>{day.Section}</h4>
              <ol>
                {day.Content.split(";").map((item, idx) => (
                  <li key={idx}>{item.trim()}</li>
                ))}
              </ol>
            </div>
          ))}
        </div>
      </section>

      <section className="inc-exc">
        <div className="inclusions">
          <h4>Trip Inclusions</h4>
          <ul>{inclusions.map((item, idx) => <li key={idx}>{item}</li>)}</ul>
        </div>
        <div className="exclusions">
          <h4>Trip Exclusions</h4>
          <ul>{exclusions.map((item, idx) => <li key={idx}>{item}</li>)}</ul>
        </div>
      </section>

      <section className="image-slider">
        <h4>Trip Views</h4>
        <div className="image-row">
          {images.map((url, idx) => (
            <img src={url} alt={`Slide ${idx}`} key={idx} />
          ))}
        </div>
      </section>

      <div className="trip-buttons">
        <a href={`https://wa.me/919999999999?text=I want to know more about *${title}*`} target="_blank" rel="noreferrer">
          <button className="know-more-btn">Know More</button>
        </a>
        <button
  className="book-now-btn"
  onClick={() => navigate(`/trip-booking/${encodeURIComponent(title)}`)}
>
  Book Now
</button>
      </div>
    </div>
  );
};

export default TripItinerary;
